module.exports = __webpack_public_path__ + "static/media/logo-prix-excellence.40937b8d.jpg";